var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",on:{"click":_vm.itemClick}},[(_vm.logo !== true)?_c('img',{staticClass:"fba-logo",attrs:{"src":require("../../assets/img/logo3.png"),"alt":""}}):_c('img',{staticClass:"fba",attrs:{"src":require("../../assets/img/logo3.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }